import { render } from "./A4Form.vue?vue&type=template&id=a6e07aba&scoped=true"
import script from "./A4Form.vue?vue&type=script&lang=js"
export * from "./A4Form.vue?vue&type=script&lang=js"

import "./A4Form.vue?vue&type=style&index=0&id=a6e07aba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e07aba"]])

export default __exports__